import { createPortal } from 'react-dom';
import { useFloatingPosition } from '@hooks/useFloatingPosition';
import type { RefObject, ReactNode, CSSProperties } from 'react';

interface FloatingPortalProps {
    anchorRef: RefObject<HTMLElement | null>;
    isOpen: boolean;
    children: ReactNode;
    className?: string;
    maxHeight?: number;
    width?: number;
    panelRef?: RefObject<HTMLDivElement | null>;
}

export default function FloatingPortal({
    anchorRef,
    isOpen,
    children,
    className = '',
    maxHeight = 320,
    width,
    panelRef,
}: FloatingPortalProps) {
    const position = useFloatingPosition(anchorRef, { isOpen, maxHeight });

    if (!isOpen || !position) return null;

    const panelWidth = width ?? position.width;

    const style: CSSProperties =
        position.placement === 'bottom'
            ? {
                  position: 'fixed',
                  top: position.top,
                  left: position.left,
                  width: panelWidth,
                  maxHeight: position.maxHeight,
                  zIndex: 100,
              }
            : {
                  position: 'fixed',
                  bottom: window.innerHeight - position.top,
                  left: position.left,
                  width: panelWidth,
                  maxHeight: position.maxHeight,
                  zIndex: 100,
              };

    return createPortal(
        <div ref={panelRef} className={className} style={style}>
            {children}
        </div>,
        document.body
    );
}
